import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { type ClientError } from 'graphql-request'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandAccountUserListPage_RemoveUserOnBrandAccount(
    $input: RemoveUserOnBrandAccountInput!
  ) {
    removeUserOnBrandAccount(input: $input) {
      result
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useRemoveUserOnBrandAccountMutation = (
  options: Omit<
    UseMutationOptions<Data, ClientError, Variables['input'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (input) => graphQLRequest({ document, variables: { input } }),
    ...options,
  })
}
